/**
 * @module getTelemetryData
 */

import { TelemetryDetails } from 'owa-actionable-message-v2';
import findDataPointCategory, { DataPointType } from './findDataPointCategory';
import AriaDataPoint from '../datapoints/AriaDataPoint';
import ElementalDataPoint from '../datapoints/ElementalDataPoint';
import ActionDataPoint from '../datapoints/ActionDataPoint';
import HttpActionDataPoint from '../datapoints/HttpActionDataPoint';
import ExtendedActionDataPoint from '../datapoints/ExtendedActionDataPoint';
import RenderDataPoint from '../datapoints/RenderDataPoint';
import { AriaDataMap } from '../types/AriaDataPointTypes';

/**
 * @function
 * To get the telemetry data based on the event category
 * @param {TelemetryDetails} telemetryDetails - The telemetry details object
 * @returns A telemetry data object
 */

const getTelemetryData = (telemetryDetails: TelemetryDetails): AriaDataMap | undefined => {
    const {
        eventName,
        messageContext,
        cardDetails,
        elementDetails,
        actionContext,
        perfCheckpoints,
    } = telemetryDetails;

    if (typeof eventName === 'undefined') {
        return undefined;
    }

    const category = findDataPointCategory(eventName);
    let dataPoint: AriaDataPoint;
    switch (category) {
        case DataPointType.Elemental:
            dataPoint = new ElementalDataPoint(eventName, messageContext);
            break;

        case DataPointType.Action:
            dataPoint = new ActionDataPoint(eventName, messageContext, elementDetails);
            break;

        case DataPointType.HttpAction:
            dataPoint = new HttpActionDataPoint(
                eventName,
                messageContext,
                cardDetails,
                elementDetails,
                actionContext
            );
            break;

        case DataPointType.ExtendedAction:
            dataPoint = new ExtendedActionDataPoint(
                eventName,
                messageContext,
                elementDetails,
                perfCheckpoints
            );
            break;

        case DataPointType.Render:
            dataPoint = new RenderDataPoint(
                eventName,
                messageContext,
                cardDetails,
                elementDetails,
                actionContext,
                perfCheckpoints
            );
            break;
    }
    return dataPoint.getProperties();
};

export default getTelemetryData;
